import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirects the retired `/deals/:implementationId/deliverables` page (and the
 * older `/files` path before it) to the deal page, which now lists every period
 * beneath the one in view. Keeps old links and bookmarks landing on the deal.
 */
export const DealPageRedirect = (): React.ReactElement => {
  const { implementationId } = useParams<{ implementationId: string }>();
  return <Navigate to={`/deals/${implementationId ?? ''}`} replace />;
};
